//Impuestos
export let IGV = 0.18;
export let ICBPER = 0.50;
export let IVAP = 0.04;

export let IGV_INCLUIDO = IGV + 1;

const DEFAULT_IMPUESTOS = {
    IGV: IGV,
    ICBPER,
    IVAP,
}

const fetchImpuestos = async () => {
    try {
        const req = await fetch('/api/config/impuestos/');

        if (!req.ok) {
            throw new Error(await req.text());
        }

        const impuestos = {}

        const data = await req.json()

        data.forEach((i) => {
            impuestos[i.Nombre] = i.Valor
        });

        return { ...DEFAULT_IMPUESTOS, ...impuestos }
    } catch (e) {
        console.error(e);
    }

    return { ...DEFAULT_IMPUESTOS }
}

export async function loadImpuestos() {
    const impuestos = await fetchImpuestos();

    IGV = impuestos.IGV;
    ICBPER = impuestos.ICBPER;
    IVAP = impuestos.IVAP;
}

//Tipos de PrecioPlantilla
export const PRECIO_COSTO = 1;
export const PRECIO_MENOR = 2;
export const PRECIO_MAYOR = 3;
export const PRECIO_VALE = 4;
export const PRECIO_FAMILIAR = 5;
export const PRECIO_ESPECIAL = 6;

//TIPOS COMPROBANTE
export const FACTURA = 2;
export const BOLETA = 4;
export const VALE = 1;
export const NOTA_DEBITO = 7;
export const NOTA_DE_CREDITO = 8;
export const NOTA_EGRESO = 53;
export const NOTA_INGRESO = 52;
export const ORDEN_COMPRA = 55;
export const GUIA_REMISION = 9;
export const GUIA_REMISION_TRANSPORTISTA = 31;

//TIPOS PAGO
export const EFECTIVO = 1;
export const PEDIDOSYA = 2;
export const POS = 3;
export const CIRKULA = 4;
export const OTROS = 5;
export const PAGO_CREDITO = 6;
export const FPAY = 7;
export const TUNKI = 8;
export const PLIN = 9;
export const YAPE = 10;
export const RAPPI = 11;
export const PAGO_CONTADO = 12;
export const PEDIDO = 13;


export function getTiposPago() {
    return [EFECTIVO, PEDIDOSYA, POS, CIRKULA, OTROS, PAGO_CREDITO, FPAY];
}

//MODALIDAD PAGO
export const CONTADO = 1;
export const CREDITO = 2;
export const MIXTO = 3;
export const OTRA_MODALIDAD_PAGO = 4;

//TIPO DOCUMENTO CLIENTE
export const RUC = 6;
export const DNI = 1;
export const CARNE_EXTRANJERIA = 4;
export const PASAPORTE = 7;
export const GENERICO = 99;
export const CEDULA_DIPLOMATICA_IDENTIDAD = 'A';

//PLAZOS DE CRÉDITOS
export const QUINCEDIAS = 1;
export const TREINTADIAS = 2;
export const CUARENTAYCINCODIAS = 3;
export const SESENTADIAS = 4;
export const NOVENTADIAS = 5;
export const CIENTOVEINTEDIAS = 6;
export const CIENTOCINCUENTADIAS = 7;
export const CIENTOOCHENTADIAS = 8;

//IdGrupoAfectacionIGV
export const GRAVADA = 1;
export const EXONERADA = 2;
export const INAFECTA = 3;
export const EXPORTACION = 4;

export const TIPO_MOV_CAJA = {
    SALIDA: "Salida",
    ENTRADA: "Entrada",
}

export const ESTADO_CE = {
    ACEPTADO: "Aceptado",
    ANULADO: "Anulado",
    PENDIENTE: "Pendiente",
    RECHAZADO: "Rechazado",
    NINGUNO: "",
}

export const TIPOS_DOC_SUNAT = {
    OTROS: -1
}

export const COD_TIPO_AFECTACION = {
    INAFECTO_BONIFICACION: '31',
    INAFECTO_ONEROSA: '30',
    EXONERADO_ONEROSA: '20',
    EXONERADO_GRATUITO: '21',
}

//TRIBUTOS
export const TRIBUTO = {
    IGV: 1,
    IVAP: 2,
    ISC: 3,
    ICBPER: 4,
    EXPORTACION: 5,
    GRATUITO: 6,
    EXONERADO: 7,
    INAFECTO: 8,
    OTROS: 9,
}

// Motivo de traslado para guia de remision

export const MOTIVO_TRASLADO = {
    ENTRE_ALMACENES: 6
}

//Ajuste de decimales -- documentacion: https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Math/floor
export const decimalAdjust = function (type, value, exp) {
    // Si el exp no está definido o es cero...
    if (typeof exp === "undefined" || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // Si el valor no es un número o el exp no es un entero...
    if (isNaN(value) || !(typeof exp === "number" && exp % 1 === 0)) {
        return NaN;
    }
    // Shift
    value = value.toString().split("e");
    value = Math[type](+(value[0] + "e" + (value[1] ? +value[1] - exp : -exp)));
    // Shift back
    value = value.toString().split("e");
    return +(value[0] + "e" + (value[1] ? +value[1] + exp : exp));
}

/** Redondeo decimal
 * Numero, numero de redondeo--- ejemplo round(15.33656, 2)
 * @param {Float} value
 * @param {Int} exp
 */
export const round = function (value, exp) {
    return decimalAdjust('round', value, -exp);
};
// Redondeo hacia abajo
export const floor = function (value, exp) {
    return decimalAdjust('floor', value, -exp);
};
// Redondeo hacia arriba
export const ceil = function (value, exp) {
    return decimalAdjust('ceil', value, -exp);
};
// Formatea una objeto tipo date
export const formatDate = (date, formatstring) => {
    switch (formatstring) {
        case 'dd-mm-yyyy':
            return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
        case 'yyyy-mm-dd': {
            const mes = date.getMonth() + 1;
            const dia = date.getDate();
            return `${date.getFullYear()}-${mes < 10 ? `0${mes}` : mes}-${dia < 10 ? `0${dia}` : dia}`;
        }
        default:
            return `${date.getMonth() + 1}-${date.getDate()}-${date.getFullYear()}`
    }
}

export async function findPersonaNaturalByDni(dni) {
    let res = await fetch(`/api/clientes/dni/${dni}`);
    let data = await res.json();

    const nombreCompleto = data.name.trim();

    const partes = nombreCompleto.split(',');
    const partesApellidos = partes[0]?.trim() || '';
    const partesNombres = partes[1]?.trim() || '';

    const apellidosArray = partesApellidos.split(' ').filter(p => p.length > 0);

    const prefijosCompuestos = ['DE', 'DEL', 'DE LA', 'DE LOS', 'DE LAS',];

    let apellidoPaterno = '';
    let apellidoMaterno = '';

    if (apellidosArray.length >= 2) {
        if (prefijosCompuestos.includes(apellidosArray[0].toUpperCase())) {
            apellidoPaterno = apellidosArray.slice(0, 2).join(' ');
            apellidoMaterno = apellidosArray.slice(2).join(' ');
        } else {
            apellidoPaterno = apellidosArray[0];
            apellidoMaterno = apellidosArray.slice(1).join(' ');
        }
    } else if (apellidosArray.length === 1) {
        apellidoPaterno = apellidosArray[0];
    }

    const nombres = partesNombres.split(' ').filter(n => n.length > 0).join(' ');

    return {
        "nombres": nombres,
        "apPaterno": apellidoPaterno,
        "apMaterno": apellidoMaterno,
    };
}

export function calcularTotales(items) {
    const gravados = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !i.Gratuito)
        .map(i => {
            return { ...i, PrecioVenta: i.PrecioVenta / IGV_INCLUIDO }
        })
        .map(i => (i.PrecioVenta * i.Cantidad) - (i.Descuento / IGV_INCLUIDO))
        .reduce((a, b) => a + b, 0)

    const exonerados = items.filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const inafectos = items.filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const gratuitos = items.filter(i => i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const icbper = items
        .filter(i => String(i.IdAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER))
        .map(i => i.Cantidad * 0.3)
        .reduce((a, b) => a + b, 0);

    const baseConIgv = (gravados * IGV_INCLUIDO)

    const total = baseConIgv + exonerados + inafectos + icbper;

    let totalForRound = total;

    if (!(Math.floor(total) === total) && total.toFixed(2) != total) {
        totalForRound = (Number(gravados.toFixed(2)) * IGV_INCLUIDO) + exonerados + inafectos + icbper;
    }

    const totalRedondeado = decimalAdjust('floor', totalForRound, -1);
    const redondeo = Math.abs((total - totalRedondeado).toFixed(12));

    return {
        gravados,
        exonerados,
        inafectos,
        gratuitos,
        icbper,
        total,
        totalRedondeado,
        redondeo
    }
}

export function calcularTotalesDetMovAlmacen(items) {
    const gravados = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !i.Gratuito)
        .map(i => {
            return { ...i, PrecioVenta: i.PrecioVenta / IGV_INCLUIDO }
        })
        .map(i => (i.PrecioVenta * i.Cantidad) - (i.Descuento / IGV_INCLUIDO))
        .reduce((a, b) => a + b, 0)

    const exonerados = items.filter(i => i.IdGrupoClasificacionIgv === EXONERADA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const fletes = items.map(i => getFlete(i) * i.Cantidad).reduce((a, b) => a + b, 0);

    const inafectos = items.filter(i => i.IdGrupoClasificacionIgv === INAFECTA && !i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const gratuitos = items.filter(i => i.Gratuito)
        .map(i => i.Total)
        .reduce((a, b) => a + b, 0);

    const icbper = items
        .filter(i => String(i.IdAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER))
        .map(i => i.Cantidad * 0.3)
        .reduce((a, b) => a + b, 0);

    const baseConIgv = (gravados * IGV_INCLUIDO)

    const total = baseConIgv + exonerados + inafectos + icbper + fletes;

    const totalRedondeado = decimalAdjust('floor', total, -1);
    const redondeo = Math.abs((total - totalRedondeado).toFixed(12));

    return {
        gravados,
        exonerados,
        inafectos,
        gratuitos,
        icbper,
        total,
        totalRedondeado,
        redondeo,
        fletes,
        baseConIgv
    }
}

function getFlete(item) {
    if (!item.Flete || item.Flete == null || isNaN(item.Flete)) {
        return 0;
    }
    return parseFloat(item.Flete)
}

export function calculateCotizaciones(items) {
    let esFree = (x) => x.Gratuito === "1" || x.Gratuito === 1 || x.Gratuito === true;
    console.log({ items })
    const gravados = items.filter(i => i.IdGrupoClasificacionIgv === GRAVADA && !esFree(i))
        .map(i => {
            return { ...i, precioVenta: dr(i.precioVenta / IGV_INCLUIDO), Descuento: i.Descuento ? i.Descuento : 0 }
        })
        .map(i => (i.precioVenta * i.cantidad) - (i.Descuento / IGV_INCLUIDO))
        .reduce((a, b) => a + b, 0)

    const descuento = items.map(i => i.Descuento).reduce((a, b) => a + b, 0);
    const exonerados = items.filter(i => i.IdGrupoClasificacionIgv === EXONERADA).map(i => i.total).reduce((a, b) => a + b, 0);
    const inafectos = items.filter(i => i.IdGrupoClasificacionIgv === INAFECTA).map(i => i.total).reduce((a, b) => a + b, 0);
    const gratuitos = items.filter(i => esFree(i)).map(i => i.total).reduce((a, b) => a + b, 0);
    const icbper = items.filter(i => String(i.idAfectacionIgv) === AFECTACION_ICBPER_ID || i.Tributos.includes(TRIBUTO.ICBPER)).map(i => i.cantidad * 0.3).reduce((a, b) => a + b, 0);

    const baseConIgv = Number((gravados * IGV_INCLUIDO).toFixed(6))

    const total = baseConIgv + exonerados + inafectos + icbper;
    const totalRedondeado = decimalAdjust('floor', baseConIgv + exonerados + inafectos + icbper, -1);
    const redondeo = Math.abs(Number(total - totalRedondeado).toFixed(12));

    return {
        gravados,
        exonerados,
        inafectos,
        gratuitos,
        icbper,
        total,
        totalRedondeado,
        redondeo,
        descuento
    }
}

export function calcTotal(item, doDiscount = false, attrCant = 'Cantidad', attrPv = 'PrecioVenta') {
    item[attrCant] = Number(item[attrCant])
    item[attrPv] = Number(item[attrPv])

    if (item.IdGrupoClasificacionIgv === EXONERADA || item.IdGrupoClasificacionIgv === INAFECTA)
        return item[attrCant] * item[attrPv];

    const pv = (item[attrPv] / IGV_INCLUIDO)
    return dr((pv * IGV_INCLUIDO * item[attrCant]) - (doDiscount ? item.Descuento : 0), 'floor', 13, 6);
}

export const NUMBER_KEYS = {
    THREE_NUMBER_KEY: 51
}

export const ESTADO_VENTA = {
    PROCESADA: "PROCESADA",
    ANULADA: "ANULADA",
};

export const ESTADO_VALE = {
    PENDIENTE: "PENDIENTE",
    PROCESADO: "PROCESADO",
    ANULADO: "ANULADO",
};

export const TIPO_STOCK = {
    CON_COMPROBANTE: 1,
    SIN_COMPROBANTE: 2,
    CON_COMPROBANTE_PREVENTA: 3,
    STOCK_COMPROMETIDO_VALE: 4,
    SIN_COMPROBANTE_PREVENTA: 5,
}

export const ESTADO_PREVENTA = {
    PROCESADA: "PROCESADA",
    CANCELADA: "CANCELADA",
    GENERADO: "GENERADO"
};

export function convertStrToJson(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return {};
    }
}

export const AFECTACION_ICBPER_ID = '19';

export const ID_TIPO_MOV_ALMACEN = {
    INGRESO: 1,
    SALIDA: 2
};

export const ID_TIPO_TRANSACCION = {
    ID_COMPRA_NACIONAL: 2,
    ID_BONIFICACION: 7,
    ID_RETIRO: 12,
    ID_TRANSFERENCIA_ENTRE_ALMACENES: 21
}

export default function dr(n, type = 'floor', places = 13, fix = 12) {
    return Number(Number(decimalAdjust(type, n, places * -1)).toFixed(fix));
}

export function doDownload(url, filename) {

    fetch(url).then(function (t) {
        return t.blob().then((b) => {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(b);
            a.setAttribute("download", filename);
            a.click();
        }
        );
    });
}
